import type { RouteLocationNormalizedLoaded } from 'vue-router';

import { AssetType } from '~/apiClient';
import type { PlatformBusClass } from '~/apiClient';
import { ROUTE_NAMES } from '~/constants/routes';

export type OptionalParams = {
    localizedClass: string | undefined;
    brandUrlKey: string | undefined;
    modelUrlKey: string | undefined;
};

export type OptionalParamKey = keyof OptionalParams;

export type ParsedRouteParams =
    | ({
          assetType: undefined;
          platformClass: undefined;
      } & Record<OptionalParamKey, undefined>)
    | ({
          assetType: AssetType;
          platformClass?: PlatformBusClass;
      } & Record<OptionalParamKey, string | undefined>);

export type UseSlpParsedRouteParamsState = Ref<ParsedRouteParams>;

export const getSlpParsedRouteParamsInitialData = (): ParsedRouteParams => ({
    assetType: undefined,
    platformClass: undefined,
    localizedClass: undefined,
    brandUrlKey: undefined,
    modelUrlKey: undefined,
});

const ROUTE_NAME_TO_STATE_KEY_MAP = {
    [ROUTE_NAMES.AUCTION_LISTING]: 'alpParsedRouteParams',
    [ROUTE_NAMES.DIRECT_SALE_LISTING]: 'dslpParsedRouteParams',
} as const;

export const useSlpParsedRouteParamsState = (route: RouteLocationNormalizedLoaded): UseSlpParsedRouteParamsState => {
    const routeBaseName = useRouteBaseName();
    const routeName = routeBaseName(route);

    if (!isSlpRoute(routeName)) {
        throw Error('useSlpParsedRouteParamsState has been called outside slp route');
    }

    return useState<ParsedRouteParams>(ROUTE_NAME_TO_STATE_KEY_MAP[routeName], getSlpParsedRouteParamsInitialData);
};
